// extracted by mini-css-extract-plugin
export default {"InitialFeeReceiptPage":"InitialFeeReceiptPage_InitialFeeReceiptPage__ax1iL","fileUploadContainer":"InitialFeeReceiptPage_fileUploadContainer__vRrAf"};